import { createRouter, createWebHistory } from 'vue-router'
import { routes } from './routes'
import { registerRouterGuards } from './guards'
import { registerRouteBusy } from '@/shared/composables/useRouteBusy'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes,
})

registerRouterGuards(router)
registerRouteBusy(router)

export default router
